<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-select placeholder="所属流程" allowClear show-search :filter-option="filterOption" class="a_input_self margin_self"
			 v-model="queryParam.key" @keyup.enter.native="$refs.table.refresh(true)">
				<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
					{{ item.name }}
				</a-select-option>
			</a-select>
			<a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
			<a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
			<a-button v-if="removeEnable" :disabled="selectedRowKeys.length === 0" type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
			<a-upload style="margin-left: 20px" v-if="addEnable" name="file" :action="uploadUrl" :headers="headers"
			 :showUploadList="false" @change="uploadChange">
				<a-button icon="upload">部署流程文件</a-button>
			</a-upload>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<s-table size="default" ref="table" rowKey="deploymentId" :rowSelection="rowSelection" :columns="columns" :data="loadData"
			 :scroll="{  y: scroll_y }">
				<span slot="serial" slot-scope="text, record, index">
					{{ index + 1 }}
				</span>
				<span slot="resourceName" slot-scope="text, record">
					<a @click="handleModelXml(record)">{{ text }}</a>
				</span>
				<span slot="dgrmResourceName" slot-scope="text, record">
					<a @click="handleShowImage(record.deploymentId)">{{ text }}</a>
				</span>
				<span slot="action" slot-scope="text, record">
					<a-popconfirm placement="topRight" title="该操作会一并 激活/挂起 所有流程实例?" @confirm="handleState(record)" okText="是"
					 cancelText="否" v-if="editEnabel">
						<a-icon slot="icon" type="question-circle-o" style="color: red" />
						<a>{{ record.suspensionState === 1 ? '挂起' : '激活' }}</a>
					</a-popconfirm>
					<a-divider v-if="editEnabel" type="vertical" />
					<a v-if="editEnabel" @click="handleNode(record.id)">节点配置</a>
					<a-divider v-if="removeEnable" type="vertical" />
					<a v-if="removeEnable" @click="delByIds([record.deploymentId])">删除</a>
				</span>
			</s-table>
		</div>

		<a-modal :visible="previewVisible" :width="900" :footer="null" @cancel="previewCancel">
			<img style="width: 100%" :src="previewImage" />
		</a-modal>
	</div>
</template>

<script>
	import storage from 'store'
	import {
		ACCESS_TOKEN
	} from '@/store/mutation-types'
	import {
		STable
	} from '@/components'
	import {
		audit_list,
	} from '@/api/financial'
	// eslint-disable-next-line no-unused-vars
	import {
		getProfList,
		delProf,
		diagram,
		modelXml,
		processState,
		deployByFileURL
	} from '@/api/activiti'
	import {
		checkPermission
	} from '@/utils/permissions'

	export default {
		name: 'ProfList',
		components: {
			STable,
		},
		data() {
			return {
				scroll_y: 150,
				visible: false,
				labelCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 5
					},
				},
				wrapperCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 16
					},
				},
				form: this.$form.createForm(this),
				mdl: {},
				permissions: [],
				// 高级搜索 展开/关闭
				advanced: false,
				// 查询参数
				queryParam: {},
				// 表头
				columns: [{
						title: '#',
						scopedSlots: {
							customRender: 'serial'
						},
					},
					{
						title: '名称',
						dataIndex: 'name',
					},
					{
						title: '流程定义key',
						dataIndex: 'key',
					},
					{
						title: '版本',
						dataIndex: 'version',
					},
					{
						title: '流程发布时间',
						dataIndex: 'deployTime',
					},
					{
						title: '部署ID',
						dataIndex: 'deploymentId',
					},
					{
						title: '资源名称',
						dataIndex: 'resourceName',
						scopedSlots: {
							customRender: 'resourceName'
						},
					},
					{
						title: '流程图名称',
						dataIndex: 'dgrmResourceName',
						scopedSlots: {
							customRender: 'dgrmResourceName'
						},
					},
					{
						title: '操作',
						width: '200px',
						dataIndex: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					},
				],
				// 加载数据方法 必须为 Promise 对象
				loadData: (parameter) => {
					return getProfList(Object.assign(parameter, this.queryParam))
				},
				previewVisible: false,
				previewImage: '',
				Approvallist: [],
				uploadUrl: process.env.VUE_APP_API_BASE_URL + deployByFileURL,
				headers: {
					token: storage.get(ACCESS_TOKEN),
				},
				selectedRowKeys: [],
				selectedRows: [],
				addEnable: checkPermission('activiti:prof:add'),
				editEnabel: checkPermission('activiti:prof:edit'),
				removeEnable: checkPermission('activiti:prof:remove'),
			}
		},
		computed: {
			rowSelection() {
				return {
					selectedRowKeys: this.selectedRowKeys,
					onChange: this.onSelectChange,
					getCheckboxProps: (record) => ({
						// props: {
						//   disabled: record.deploymentId, // Column configuration not to be checked
						//   name: record.name
						// }
					}),
				}
			},
		},
		filters: {},
		created() {
			audit_list().then(res => {
				this.Approvallist = res.data
			})
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $(".ant-table-header").height() - 50;
				}, 1000);
			})
		},
		methods: {
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRowKeys = selectedRowKeys
			},
			handleNode(procDefId) {
				this.$router.push({
					name: 'procDefNode',
					query: {
						procDefId: procDefId
					}
				})
			},
			handleOk() {
				this.$refs.table.refresh(true)
				console.log('handleSaveOk')
			},
			dataModal(dictType) {
				this.$refs.datamodal.show(dictType)
			},
			previewCancel() {
				this.previewVisible = false
			},
			handleShowImage(did) {
				diagram(did).then((res) => {
					const raw = res.data
					this.previewImage = URL.createObjectURL(raw)
				})
				this.previewVisible = true
			},
			uploadChange(info) {
				if (info.file.status !== 'uploading') {
					console.log(info.file, info.fileList)
				}
				if (info.file.status === 'done') {
					this.$refs.table.refresh(true)
				}
			},
			handleModelXml(record) {
				modelXml(record.deploymentId).then((res) => {
					const aLink = document.createElement('a')
					var blob = new Blob([res.data], {
						type: 'application/xml'
					})
					var fileName = record.resourceName
					aLink.href = URL.createObjectURL(blob)
					aLink.setAttribute('download', fileName) // 设置下载文件名称
					document.body.appendChild(aLink)
					aLink.click()
					document.body.removeChild(aLink)
					window.URL.revokeObjectURL(aLink.href)
				})
			},
			handleState(record) {
				const state = record.suspensionState === 1 ? 'suspend' : 'active'
				processState(record.id, state).then((res) => {
					if (res.code === 200) {
						record.suspensionState = record.suspensionState === 1 ? 2 : 1
					}
				})
			},
			delByIds(ids) {
				// this.$message.error('演示环境无法操作')
				delProf({
					ids: ids.join(',')
				}).then((res) => {
					if (res.code === 200) {
						this.$message.success(`删除成功`)
						this.handleOk()
						this.selectedRowKeys = []
					} else {
						this.$message.error(res.msg)
					}
				})
			},
		},
		watch: {
			/*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
		},
	}
</script>
